/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import url from 'url';

export function urlCheck(testUrl: string): boolean {
    const parsedUrl = url.parse(testUrl, true);
    if (parsedUrl.protocol && parsedUrl.host) {
        return true;
    } else {
        return false;
    }
}
